import { catalogApi as apiClient, catalogConfig, readCatalogPages, useCatalogResource } from "../components/catalog/catalogResources";

export async function loadServiceFormOptions(companyId, signal, search, selectedIds) {
  const [warehouses, page, selected] = await Promise.all([
    readCatalogPages("/api/warehouses", "warehouses", companyId, signal),
    apiClient.get("/api/produits", catalogConfig(companyId, signal, { page: 1, limit: 50, search })),
    Promise.all(Array.from({ length: Math.ceil(selectedIds.length / 100) }, (_, index) =>
      apiClient.get("/api/produits/by-ids", catalogConfig(companyId, signal, { ids: selectedIds.slice(index * 100, (index + 1) * 100).join(",") })))),
  ]);
  if (!Array.isArray(page.data?.products) || selected.some((response) => !Array.isArray(response.data?.products))) {
    throw new Error("Les choix de produits sont indisponibles.");
  }
  const products = [...page.data.products, ...selected.flatMap((response) => response.data.products)];
  return { warehouses: warehouses.map(({ id, name }) => ({ id, name })),
    products: Array.from(new Map(products.map(({ id, name, product_type, production_kind, stock_management_mode }) =>
      [Number(id), { id: Number(id), name, product_type, production_kind, stock_management_mode }])).values()),
    selectedProducts: selected.flatMap((response) => response.data.products).map(({ id }) => ({ id })),
  };
}

export default function useServiceFormOptions(scope, open, search, selectedIds) {
  return useCatalogResource("service-form-options", scope,
    (signal) => loadServiceFormOptions(scope.companyId, signal, search, selectedIds), [search, selectedIds.join(",")], open, open);
}
